/**
 * 
 * ArticlesList.js
 * 
 */
export default class ArticlesList {

    constructor() {
        this.name = 'ArticlesList';
        this.articlesLists            = document.querySelectorAll('.js-articles-list');
        this.itemsPerPage             = 10;

        if (this.articlesLists.length) {
            this._init();
        }
    }

    // Public Functions
    
    
    // 'Private' Functions
    _init() {
        /**
         * 
         *  Loop through all Articles Lists, see if any of them have more than 
         *  this.itemsPerPage.length, and paginate if so.
         * 
         * */
        for (var i = 0; i < this.articlesLists.length; i ++) {

            let articlesList = this.articlesLists[i];
            
            if (articlesList.querySelectorAll('article').length > this.itemsPerPage) {
                this._paginateArticlesList(articlesList);
            }
        }
    }

    _paginateArticlesList(articlesList) {

        let numArticles = articlesList.querySelectorAll('article').length,
            numPages = Math.ceil(numArticles / this.itemsPerPage),
            pagination = articlesList.querySelector('.articles-list__pagination'),
            paginationList = articlesList.querySelector('ul'),
            paginationHtml = '',
            prevBtn = pagination.querySelector('.prev'),
            nextBtn = pagination.querySelector('.next'),
            numberBtns;

        /**
         * 
         * Populate paginationList with numbered buttons for each page
         * 
         *  */
        for (let i = 1; i <= numPages; i ++) {
            paginationHtml += `<li data-page="${i}"><a href="#">${i}</a></li>`;
        }
        paginationList.innerHTML = paginationHtml;


        /**
         * 
         * Add click events to buttons
         * 
         * */
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this._previousPage(articlesList);
        });

        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this._nextPage(articlesList, numPages);
        });

        numberBtns = paginationList.querySelectorAll('li');
        for (let i = 0; i < numberBtns.length; i ++) {
            //console.log(numberBtns[i]);
            let btn = numberBtns[i];
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this._numberBtnsHandler(e, articlesList);
            });
        }

        
        /**
         * 
         * Make pageination visible
         * 
         * */
        pagination.classList.add('active');


        /**
         * Show first page
         */
        this._gotoPage(articlesList, 1, false);


    }

    _selectNumberBtn(articlesList, currentPage) {
        let paginationList = articlesList.querySelector('ul');
        let numberBtns = paginationList.querySelectorAll('li');

        for (let i = 0; i < numberBtns.length; i ++) {
            let val = numberBtns[i];
            val.classList.remove('active');
            if (val.getAttribute('data-page') == currentPage.toString()) {
                val.classList.add('active');
            }
        }
    }

    _numberBtnsHandler(e, articlesList) {
        let pageNum = e.currentTarget.getAttribute('data-page');
        articlesList.setAttribute('data-current-page', pageNum);
        this._gotoPage(articlesList);
    }

    _previousPage(articlesList) {
        // console.log('_previousPage');
        let currentPage = articlesList.getAttribute('data-current-page');
        if (currentPage == 1) {
            return;
        } else {
            currentPage --;
            articlesList.setAttribute('data-current-page', currentPage);
        }
        this._gotoPage(articlesList);
    }
    
    _nextPage(articlesList, numPages) {
        // console.log('_nextPage');
        let currentPage = articlesList.getAttribute('data-current-page');
        if (currentPage == numPages) {
            return;
        } else {
            currentPage ++;
            articlesList.setAttribute('data-current-page', currentPage);
        }
        this._gotoPage(articlesList);
    }

    _gotoPage(articlesList, pageNum, animate) {
        if (animate == undefined) {
            TweenMax.to(window, 1, {scrollTo: { y: articlesList, offsetY: 25 }});
        }

        let currentPage = articlesList.getAttribute('data-current-page');

        if (pageNum) {
            currentPage = pageNum;
        }

        /**
         * Deselect selected pagination number, and select new page
         */
        this._selectNumberBtn(articlesList, currentPage);


        // console.log('Show page: ' + currentPage);
        let articles = articlesList.querySelectorAll('article');
        let numArticles = articles.length;

        /**
         * Remove 'visible' class from any visible articles
         */
        for (let i = 0; i < numArticles; i ++ ) {
            articles[i].classList.remove('visible');
        }

        /**
         * Get start and end of current page
         */
        let end = currentPage * this.itemsPerPage;
        let begin = end - this.itemsPerPage;
        if (end > numArticles) {
            end = numArticles;
        }

        for (let i = begin; i < end; i ++ ) {
            // console.log(i);
            articles[i].classList.add('visible');
        }
    }
}
